


































































































import {
  defineComponent,
  ComponentInternalInstance,
  getCurrentInstance,
  ref,
  onUnmounted,
  computed,
  onMounted,
  watch,
  toRefs,
} from '@vue/composition-api';
import { EllipsisIcon } from 'tdesign-icons-vue';
import { DropdownOption } from 'tdesign-vue';
import userAvatar from '@/renderer/components/user/components/userAvatar.vue';
import vistorAvatar from '@/renderer/components/user/components/vistorAvatar.vue';
import settingDialog from '@/renderer/components/dialog/setting/index.vue';
import LoginPage from '@/renderer/components/login/components/index.vue';
import OffenceDialog from '@/renderer/views/share/components/offenceDialog.vue';
import i18n, { i18n_t, LanguageOptions } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import { getOfficialWebsiteUrl, getOrgNameState } from '@/renderer/scripts/utils/tools/index';
import user, { User } from '@/renderer/scripts/utils/user';
import { authAndLogin } from '@/renderer/scripts/utils/meeting/autoLoginInMeeting';
import { OrgLogoInfo } from '@/renderer/scripts/libs/smh-sdk-class/typings';

import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { setLanguage } from '@/locales/languageSettingMethod';
import rendererHandler from '../composition/generalRendererHandler';
import baseHeadbarHandler from '../composition/baseHeadbarHandler';

export default defineComponent({
  components: {
    EllipsisIcon,
    userAvatar,
    vistorAvatar,
    settingDialog,
    LoginPage,
    OffenceDialog,
  },
  props: {
    orgLogoInfo: {
      type: Object as () => OrgLogoInfo,
      require: true,
      default: () => {
        return {
          orgLogo: '',
          orgName: '',
          showOrgNameInUI: undefined,
        };
      },
    },
  },
  inject: {
    hideLoginEntry: {
      default: () => false,
    },
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const isLogined = computed(() => store.getters.isLogined);
    const isVistorLogined = computed(() => store.getters.isVistorLogined);
    const hideMoreLoginMethods = ref(false); // 是否屏蔽更多登录方式入口（第三方登录时需屏蔽）
    const { orgLogoInfo } = toRefs(props);

    const { envHelp, goToIndexPage } = baseHeadbarHandler();
    const {
      methods: headBarMethods,
      orgLogo,
      orgName,
      showOrgName,
      showSetting,
      showLogin,
      vistorLogin,
      isShareRoute,
    } = rendererHandler(orgLogoInfo);
    // 点击右上角登录（默认）或点击进入群组时触发的登录'' | 'login' | 'loginToJoin'
    const loginFrom = ref('');
    const offenceDialogShow = ref(false);
    const options = [
      {
        content: i18n_t('举报文件'),
        value: 'offence',
      },
    ];
    const languageOptions = ref(LanguageOptions);

    const methods = {
      showLoginFun(loginFromWhere = '', hide = false) {
        loginFrom.value = loginFromWhere;
        showLogin.value = true;
        hideMoreLoginMethods.value = hide;
      },
      closeLoginFun() {
        vistorLogin.value = false;
        store.commit('SET_APPROVED_AGREEMENT', false);
      },
      openLoginDialog() {
        // 会议里直接授权登录
        if (store.getters.isInWeMeetApp) {
          authAndLogin((params: any) => {
            dispatchRouter(params, 'replace');
          });
          return;
        }
        // 其他端弹窗登录弹窗
        showLogin.value = true;
        hideMoreLoginMethods.value = false;
        user.setLoginAction(User.LoginActionKey.login);
        user.setLoginFunc('');
      },
      // 登录成功回调
      logined() {
        // 加载用户头像
        headBarMethods.onLoginSuccess();
        ipc.emit(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_LOGINED, loginFrom.value);
      },
      // 游客登录成功回调
      vistorLogined() {
        // 加载用户头像
        headBarMethods.onVistorLoginSuccess();
        ipc.emit(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_LOGINED, loginFrom.value);
      },
      openDownloadPC() {
        const downloadUrlInBrowser = `${getOfficialWebsiteUrl()}/download`;
        dispatchRouter(downloadUrlInBrowser, '_blank');
      },
      // 免费注册
      freeRegister() {
        const routerName = vm.$route.name || '';
        // 分享类页面的注册需要打开另一个新的页面
        const newpage = vm.$router.resolve({
          path: '/login/register',
          query: {
            from: routerName,
          },
        });
        dispatchRouter(newpage?.href, '_blank');
      },
      onLanguageChange(dropdownItem: DropdownOption) {
        setLanguage(dropdownItem.value as string);
      },
    };

    // 个人、企业信息每5分钟定时查询
    let timer: null | number = null;
    const refresh = async () => {
      if (!store.getters.isLogined) return;
      const { userId, organizationId } = user.getUserInfo();
      // 有个人空间时轮询个人空间使用量
      if (store.getters.hasPersonalSpace) {
        store.dispatch('checkPersonalSpace');
      }
      await store.dispatch('getUserBaseInfo');
      store.dispatch('GetOrgInfo', organizationId);
      // 管理员权限查询企业配额
      if (store.getters.userBaseInfo.role !== 'user') {
        store.dispatch('GetOrgSpace');
      }
    };
    const intervalRefresh = () => {
      refresh();
      timer = window.setTimeout(intervalRefresh, 5 * 60 * 1000);
    };
    intervalRefresh();
    watch(
      () => store.getters.isLogined,
      val => {
        if (val) {
          // 登录进来或者刷新都获取一次是否有个人空间
          store.dispatch('checkPersonalSpace');
        }
      },
      {
        immediate: true,
      },
    );
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW, methods.showLoginFun);
      ipc.on(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_HIDE, methods.closeLoginFun);
    });
    onUnmounted(() => {
      timer && window.clearTimeout(timer);
      ipc.off(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW, methods.showLoginFun);
      ipc.off(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_HIDE, methods.closeLoginFun);
    });

    // 计算名称的长度
    const lengthState = computed(() => {
      const name = orgName.value;
      return getOrgNameState(name, 'orgName');
    });
    const showReport = computed(() => {
      const { name } = vm.$router.currentRoute;
      return ['collect', 'share'].includes(name || '');
    });
    return {
      isLogined,
      isVistorLogined,
      envHelp,
      orgLogo,
      orgName,
      showOrgName,
      showSetting,
      showLogin,
      vistorLogin,
      loginFrom,
      hideMoreLoginMethods,
      isShareRoute,
      lengthState,
      offenceDialogShow,
      options,
      showReport,
      languageOptions,
      ...methods,
      ...headBarMethods,
    };
  },
});
